import { Routes, Route } from "react-router-dom";
import HeaderResaleProject from "../Components/Project Resale/headerResaleProject";
import ListProjectResale from "../Components/Project Resale/listResaleProject";
import ListInterestedProjectResale from "../Components/Project Resale/listInterestedProjectResale";
import UserProjectViewList from "../Components/Project Resale/userProjectView";
import AddProjectResale from "../Components/Project Resale/addResaleProject";
import EditProjectResale from "../Components/Project Resale/editResaleProject";
import ViewProjectResale from "../Components/Project Resale/viewResaleProject";

const ProjectResaleRoutes = () => {
  return (
    <Routes>
      <Route path="/resale_project" element={<HeaderResaleProject />} />
      <Route path="/resale_project_list" element={<ListProjectResale />} />
      <Route path="/interested_resale_project" element={<ListInterestedProjectResale />} />
      <Route path="/user_view_resale_project" element={<UserProjectViewList />} />
      <Route path="/resale_project/add" element={<AddProjectResale />} />
      <Route path="/resale_project/edit/:id" element={<EditProjectResale />} />
      <Route path="/resale_project/view/:id" element={<ViewProjectResale />} />
    </Routes>
  );
};

export default ProjectResaleRoutes;